import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const Breadcrumb = ({ category }) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter((segment) => segment);

  const breadcrumbItems = [];

  // Home link
  breadcrumbItems.push(
    <li key="home">
      <Link to="/" className="hover:text-green-200 transition-colors">
        Home
      </Link>
    </li>
  );

  if (pathSegments.length > 0) {
    const firstSegment = pathSegments[0];
    const isArticle = pathSegments.length === 2;

    if (category && firstSegment === category.toLowerCase()) {
      breadcrumbItems.push(
        <li key="separator-1" className="text-green-300 mx-2">
          {'>'}
        </li>,
        <li key="category">
          <Link
            to={`/${category}`}
            className="hover:text-green-200 transition-colors capitalize font-medium"
          >
            {category}
          </Link>
        </li>
      );
    }

    if (isArticle) {
      const articleId = pathSegments[1];
      breadcrumbItems.push(
        <li key="separator-2" className="text-green-300 mx-2">
          {'>'}
        </li>,
        <li key="article">
          <span className="text-green-100">Article {articleId}</span>
        </li>
      );
    }
  }

  return (
    <nav className="bg-green-800 py-3 px-4 shadow-md">
      <ol className="flex items-center flex-wrap text-sm text-green-100 max-w-7xl mx-auto">
        {breadcrumbItems}
      </ol>
    </nav>
  );
};

Breadcrumb.propTypes = {
  category: PropTypes.string,
};

export default Breadcrumb;